import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent('section', 'loginStrategySelector', ['wrapper']);